import Shared from '../../asset/shared.png'
import Edit from '../../asset/pencil.png'
import Delete from '../../asset/bin.png'
import Close from '../../asset/close.png'
import { store } from '../../lib/store'
import { infoWindowOpenAction } from '../../action/infowindow-action'
import { circleDeleteRequest } from '../../action/circle-actions'
import { polygonDeleteRequest } from '../../action/polygon-actions'
import { calculateCircleProperties, calculatePolyProperties, calculateLineProperties } from './commonFunctions'
import { lineDeleteRequest } from '../../action/line-actions'
import { collapseLeftToolbar } from '../../action/left-toolbar-state-actions'
import { dateConvertion } from '../main-ui/common/commonfunctions'

const alertContainer = document.createElement('div');
alertContainer.id = 'custom-alert';
document.body.appendChild(alertContainer);

const spinner = document.createElement('div');
spinner.classList.add('spinner-content');
spinner.innerHTML = `
  <div class="loader-spinner"></div>
`;

document.body.appendChild(spinner);
spinner.style.display = 'none';

//Function to hide the alert box
function hideAlert() {
  const alertBox = document.querySelector('.custom-alert-content');
  if (alertBox) {
    alertBox.remove();
  }
}

async function remove(id, mapObj, type) {
  try {
    switch (type) {
      case 'circle':
        await store.dispatch(circleDeleteRequest(id))
        break
      case 'poly':
        await store.dispatch(polygonDeleteRequest(id))
        break
      case 'line':
        await store.dispatch(lineDeleteRequest(id))
        break
    }
    hideAlert()
    setTimeout(() => {
      mapObj.setMap(null)
    }, 1000)
  } catch (error) {
    console.log('Error at deleteFunction', error)
  }
}

const handleParentClick = (e) => {
  // Prevent the click event from reaching the parent
  e.stopPropagation();
}
// Function to show the alert box
function showAlert(message, type, id, mapObj) {
  store.dispatch(collapseLeftToolbar())
  const alertBox = document.createElement('div');
  alertBox.classList.add('custom-alert-content');
  alertBox.innerHTML = `
      <span class="close-btn" onclick="hideAlert()">&times;</span>
      <div class='confirm-removal-container-two'>
          <div class='alert-box-container'>
              <div class='alert-center'>
                  <p style="font-size: 18px; line-height: 1.5; margin: 20px; font-weight: bold; text-align: center;">Delete
                      this ${type == 'poly' ? 'polygon' : type} from
                      your map and your saved content?</p>
                  <div style="display: flex; justify-content: space-between; margin-top: 10px;">
                      <button id="close-btn" style="margin: 0; width: 45%;">CANCEL</button>
                      <button id="yes-remove"
                          style="margin: 0; background-color: #ff6800; width: 45%;">YES, DELETE</button>
                  </div>
              </div>
          </div>
      </div>
   `;
  alertContainer.appendChild(alertBox);
  // Add event listener programmatically
  alertBox.querySelector('#close-btn').addEventListener('click', hideAlert);
  alertBox.querySelector('#yes-remove').addEventListener('click', () => remove(id, mapObj, type))
  alertBox.querySelector('.alert-box-container').addEventListener('click', handleParentClick)
}

//Info Box function
export async function createContent(data, callback, dispatchFunction) {
  let { mapReference, mapObj, mapPhotoObj, marker, photo, infoWindow, openInfoWindowClose, token, shapeDetails, type, infoPosition } = data;
  let { editFunction, deleteFunction, closeFunction, updateInfoWindow, editHuntWind } = callback
  const reduxState = store.getState();
  const { userPreferences } = reduxState;
  const { auth } = reduxState
  let newInfoWindow, lineElevationVal, lineLengthVal
  // Parse the GeoJSON string to a JavaScript object
  const geoJsonObject = JSON.parse(shapeDetails.geoJson);

  //Infobox HTML content
  const infoWindowContent = () => {
    function editFunctionCb() {
      editFunction(newInfoWindow)
    }
    const deleteFunction = (type, id, mapObj) => {
      const state = store.getState();
      showAlert("Message", type, id, mapObj);
      state.infoWindow.infoWindowFunction.close();
      // store.dispatch(infoWindowOpenAction(null));
    }

    //Not using Now but in future it may impliment
    function sendEmail(latitude, longitude, markerName, markerDetails) {
      const domain = process.env.NODE_ENV === 'production' && process.env.__NOTIFICATION_ENV__ == 'production' ? 'app.basemap.com' : 'staging.basemap.com'
      // Define email details
      const to = '';
      const subject = 'BaseMap Shared Marker';
      const body = `I've shared a marker with you, click below to view in the BaseMap app. https://${domain}/marker?latitude=${latitude}&longitude=${longitude}&t=63&n=${markerName}&c=${markerDetails} Don't have the app? Download here: https://app.basemap.com.`;
      // Create a mailto URL
      const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      // Open the default email client with the predefined details
      window.location.href = mailtoURL;
    };

    const inputDate = shapeDetails && shapeDetails.created;
    const updateDated = shapeDetails && shapeDetails.updated ? shapeDetails.updated : 'NA';

    // Format the date
    const formattedDate = dateConvertion(inputDate)
    const formattedUpdatedDate = updateDated == 'NA' ? false : dateConvertion(updateDated);
    const { areaStr, radStr } = type == 'circle' && calculateCircleProperties(shapeDetails.geoJson, userPreferences);
    const { polyArea, polyPerimeter } = type == 'poly' && calculatePolyProperties(mapObj, userPreferences);

    // Create the container div
    const container = document.createElement('div');
    container.style = `padding: 10px; height: 165px; width: ${marker && (marker.markerType.usageFlag == 3) ? "190px" : "150px"}; background-color: black ; visibility: visible; border-radius:10px`;
    // Create the content HTML
    container.innerHTML =
      `
        <div style="width:100%;">
            <a id="close">
                <img style="width: 10%; height: 50%; object-fit: cover; float: right;  margin-top: -10px; " src=${Close}
                    alt="Edit"></img>
            </a>
        </div>
        <div style="width: 90%; overflow: hidden; text-overflow: ellipsis;">
            <span class="info-box-span-heading">${shapeDetails.name}</span>
        </div>
        <h6 class="info-box-head">Created: <span class="info-box-span">${formattedDate}</span></h6>
        ${formattedUpdatedDate ? `<h6 class="info-box-head">Updated: <span class="info-box-span">${formattedUpdatedDate}</span></h6>` : ''}
        <h6 class="info-box-head">${type == 'circle' ? 'Radius' : type == 'poly' ? 'Perimeter' : type == 'line' ? 'length' :
        'Line Data'}: <span class="info-box-span">${type == 'circle' ? radStr : type == 'poly' ? polyPerimeter : type ==
          'line' ? lineLengthVal : 'Line Data'}</span></h6>
        <h6 class="info-box-head">${type == 'line' ? 'Elev. Gain' : 'Area'}: <span class="info-box-span">${type == 'circle' ?
        areaStr : type == 'poly' ? polyArea : type == 'line' ? lineElevationVal : 'Line Data'}</span></h6>
        <div style="display:flex; margin-top:10px;justify-content: space-around;">
            ${false ? ` <div
                style="width: 50px; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <a id="shareButton">
                    <div
                        style="width: 30px; height: 30px; border-radius: 50%; margin-bottom: 3px;overflow: hidden; border: 2px solid green;display: flex; align-items: center; justify-content: center;">
                        <img style="width: 50%; height: 50%; object-fit: cover;" src=${Shared}></img>
                    </div>
                </a>
                <p>Share</p>
            </div>
            `: ''}
            <div
                style="width: 50px; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <a id="editButton">
                    <div
                        style="width: 30px; height: 30px; border-radius: 50%; margin-bottom: 3px;overflow: hidden; border: 2px solid green; display: flex; align-items: center; justify-content: center;">
                        <img style="width: 50%; height: 50%; object-fit: cover;" src=${Edit} alt="Edit"></img>
                    </div>
                </a>
                <p>Edit</p>
            </div>
            <div
                style="width: 50px; height: 55px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                <a id="deleteButton">
                    <div
                        style="width: 30px; height: 30px; border-radius: 50%;margin-bottom: 3px; overflow: hidden; border: 2px solid green;display: flex; align-items: center; justify-content: center;">
                        <img style="width: 50%; height: 50%; object-fit: cover;" src=${Delete}></img>
                    </div>
                </a>
                <p>Delete</p>
            </div>
        </div>
            
        <div class="triangle-container">
            <div class="triangle-shape" style="margin-bottom: 3px;"></div>
        </div>
      `;

    // Append the container to the desired parent element
    document.body.appendChild(container);

    // Add CSS for the triangle shape
    const style = document.createElement('style');
    style.innerHTML = `
      .triangle-shape {
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 30px solid #000000;
        transform: rotate(225deg);
      }
      .triangle-container {
        justify-content: center;
        align-items: center;
        position: absolute;
        left: -10px;
        bottom: -15px;
      }
      .gm-style .gm-style-iw-c {
        /* padding: 0px !important; */
        left:95px !important;
        top: 3px !important;
      }
    `;
    document.head.appendChild(style);

    // Add event listeners to the buttons
    container.querySelector('#editButton').addEventListener('click', editFunctionCb);
    container.querySelector('#deleteButton').addEventListener('click', () => deleteFunction(type, shapeDetails.id, mapObj));
    container.querySelector('#close').addEventListener('click', closeFunctionCb);
    // container.querySelector('#shareButton').addEventListener('click', () => sendEmail(value.latitude, value.longitude, encodedValue, markerDetails));

    // Append the container to the body
    document.body.appendChild(container);
    return container;
  };

  if (reduxState.infoWindow) {
    reduxState.infoWindow.infoWindowFunction && reduxState.infoWindow.infoWindowFunction.close()
  }

  let getLatLng = (geoJsonObject, type) => {
    // Extract the coordinates from the GeoJSON
    const coordinates = geoJsonObject.features[0].geometry.coordinates;
    let circleCoord
    let polyCoord
    let lineCoord
    switch (type) {
      case 'circle':
        circleCoord = { lat: coordinates[1], lng: coordinates[0] };
        return circleCoord
        break
      case 'poly':
        polyCoord = { lat: coordinates[0][0][1], lng: coordinates[0][0][0] }
        return polyCoord
        break
      case 'line':
        lineCoord = { lat: coordinates[0][1], lng: coordinates[0][0] }
        return lineCoord
        break
    }
    return circleCoord
  }

  if (type === 'line') {
    // Function to Show the spinner
    const showSpinner = () => {
      spinner.style.display = 'flex';
    };
    // Function to hide the spinner
    const hideSpinner = () => {
      spinner.style.display = 'none';
    };
    showSpinner()
    await calculateLineProperties(mapObj, auth.token, userPreferences).then(({ lineElevation, lineLength }) => {
      lineElevationVal = lineElevation;
      lineLengthVal = lineLength;
      hideSpinner()
    }).catch((err) => {
      console.error('Error:', err);
      hideSpinner()
    });
  }

  //Google API to Create the InfoWindow
  newInfoWindow = new google.maps.InfoWindow({
    content: infoWindowContent(shapeDetails),
    disableAutoPan: true,
    pixelOffset: new google.maps.Size(0, -10),
    maxWidth: 544,
    position: infoPosition ? infoPosition : getLatLng(geoJsonObject, type)
  });

  if (newInfoWindow) {
    dispatchFunction && dispatchFunction(newInfoWindow)
  }

  function closeFunctionCb() {
    closeFunction(newInfoWindow)
  }

  newInfoWindow.open(mapReference, mapObj ? mapObj : mapPhotoObj);

  newInfoWindow && updateInfoWindow(newInfoWindow)
}
